import React from 'react';
import NetworkIntelligenceFilterBar from '../components/NetworkIntelligenceFilterBar';
import PredictiveRiskPanel from '../components/PredictiveRiskPanel';
import PredictiveRiskSummaryCards from '../components/PredictiveRiskSummaryCards';
import PredictiveRiskTable from '../components/PredictiveRiskTable';
import { useNetworkIntelligenceData } from '../hooks/useNetworkIntelligenceData';
import { AppShell, PageContainer } from '../../ui-system';

const NetworkIntelligencePage = () => {
  const { summary, risks, topRisks, filters, isLoading, error, refetch } = useNetworkIntelligenceData();

  return (
    <AppShell>
      <PageContainer>
      <div className="w-full space-y-4">
        <header className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
          <div className="text-xs uppercase tracking-[0.16em] text-slate-400">Network Intelligence</div>
          <h1 className="mt-1 text-2xl font-semibold">Predictive Failure Control</h1>
          <p className="mt-1 text-sm text-slate-400">
            Panel prediktif untuk deteksi dini risiko area, PPPoE, akses kapasitas, dan konsentrasi SLA.
          </p>
        </header>

        <NetworkIntelligenceFilterBar filters={filters} onRefresh={refetch} />

        {isLoading ? (
          <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-4 text-sm text-slate-400">Memuat network intelligence...</div>
        ) : null}

        {error ? (
          <div className="rounded-xl border border-red-500/50 bg-red-500/10 p-4 text-sm text-red-200">
            {error?.message || 'Gagal memuat predictive risks'}
          </div>
        ) : null}

        {!isLoading && !error ? (
          <>
            <PredictiveRiskSummaryCards summary={summary} />
            <PredictiveRiskPanel risks={topRisks} />
            <PredictiveRiskTable risks={risks} />
          </>
        ) : null}
      </div>
      </PageContainer>
    </AppShell>
  );
};

export default NetworkIntelligencePage;
